/* eslint-disable arrow-parens */
import schoolsApi from '@/api/schools';

// initial state
const state = {
  schools: [],
  schoolSelection: [],
  schoolsOnPage: { schoolCount: 0, schools: [] },
  schoolsPaging: {
    filter: null,
    page: 1,
    pageSize: 20,
  },
  school: {},
  licenses: [],
  usersSchool: null,
  activeLicense: null,
  activeOnly: true,
};

// getters
const getters = {
  schoolSelection: (currentState) => currentState.schoolSelection,
  schools: (currentState) => currentState.schools,
  pagedSchools: (currentState) => currentState.schoolsOnPage,
  schoolsPaging: (currentState) => currentState.schoolsPaging,
  school: (currentState) => currentState.school,
  usersSchool: (currentState) => currentState.usersSchool,
  licenses: (currentState) => currentState.licenses,
  activeLicense: (currentState) => currentState.activeLicense,
  activeOnly: (currentState) => currentState.activeOnly,
};

// actions
const actions = {
  getSchools({ dispatch, commit }) {
    dispatch('showLoader');
    schoolsApi.getSchools().then((response) => {
      commit('setSchools', { schools: response.data });
      dispatch('hideLoader');
    });
  },
  getSchoolSelection({ dispatch, commit }, active) {
    dispatch('showLoader');
    schoolsApi.getSchoolSelection(active).then((response) => {
      commit('setSchoolSelection', { schoolSelection: response.data });
      dispatch('hideLoader');
    });
  },
  getPagedSchools({ dispatch, commit }, paging) {
    dispatch('showLoader');
    schoolsApi.getPagedSchools(paging).then((response) => {
      commit('setPagedSchools', { schools: response.data, paging });
      dispatch('hideLoader');
    });
  },
  getSchoolForUser({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      schoolsApi.getSchoolForUser().then(
        (response) => {
          dispatch('hideLoader');
          resolve(response);
          commit('setSchoolForUser', { usersSchool: response.data });
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  getSchool({ dispatch, commit }, id) {
    dispatch('showLoader');
    schoolsApi.getSchool(id).then((response) => {
      commit('setSchool', { school: response.data });
      dispatch('hideLoader');
    });
  },
  getSchoolLicenses({ dispatch, commit }, id) {
    dispatch('showLoader');
    schoolsApi.getSchoolLicenses(id).then((response) => {
      commit('setLicenses', { licenses: response.data });
      dispatch('hideLoader');
    });
  },
  getUnpaidLicenses({ dispatch, commit }) {
    dispatch('showLoader');
    schoolsApi.getUnpaidLicenses().then((response) => {
      commit('setLicenses', { licenses: response.data });
      dispatch('hideLoader');
    });
  },
  getActiveLicense({ dispatch, commit }) {
    dispatch('showLoader');
    schoolsApi
      .getActiveLicense()
      .then((response) => {
        commit('setActiveLicense', {
          license: response.data,
        });
      })
      .catch(() => {
        commit('setActiveLicense', { license: null });
      })
      .finally(() => {
        dispatch('hideLoader');
      });
  },
  createStripeSession({ dispatch }, school) {
    return new Promise((resolve, reject) => {
      dispatch('showLoader');
      schoolsApi.createStripeSession(school).then(
        (response) => {
          dispatch('hideLoader');
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  createSchool({ dispatch }, school) {
    return new Promise((resolve, reject) => {
      schoolsApi.createSchool(school).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  addLicense({ dispatch }, license) {
    return new Promise((resolve, reject) => {
      schoolsApi.addLicense(license.schoolId, license).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  updateLicense({ dispatch }, license) {
    return new Promise((resolve, reject) => {
      schoolsApi.updateLicense(license.schoolId, license).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  removeLicense({ dispatch }, { schoolId, licenseId }) {
    return new Promise((resolve, reject) => {
      schoolsApi.removeLicense(schoolId, licenseId).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  payLicense({ dispatch }, { schoolId, licenseId, amount }) {
    return new Promise((resolve, reject) => {
      schoolsApi.payLicense(schoolId, licenseId, { amount }).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          dispatch('hideLoader');
          reject(error);
        },
      );
    });
  },
  setActiveOnly({ commit }, activeOnly) {
    commit('setActiveOnly', { activeOnly });
  },
};

// mutations
const mutations = {
  setSchools(currentState, { schools }) {
    currentState.schools = schools;
  },
  setSchoolSelection(currentState, { schoolSelection }) {
    currentState.schoolSelection = schoolSelection;
  },
  setPagedSchools(currentState, { schools, paging }) {
    currentState.schoolsOnPage = schools;
    currentState.schoolsPaging = paging;
  },
  setSchool(currentState, { school }) {
    currentState.school = school;
  },
  setSchoolForUser(currentState, { usersSchool }) {
    currentState.usersSchool = usersSchool;
  },
  setLicenses(currentState, { licenses }) {
    currentState.licenses = licenses;
  },
  setActiveLicense(currentState, { license }) {
    currentState.activeLicense = license;
  },
  setActiveOnly(currentState, { activeOnly }) {
    currentState.activeOnly = activeOnly;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/schools.js